import { useRef, useState } from "react";
import { components } from 'react-select';

export const sortLegislations = (a, b) => {
    if (a.LegislationNumber[0] !== b.LegislationNumber[0]) {
        return a.LegislationNumber[0].localeCompare(b.LegislationNumber[0]);
    } else if (a.LegislationNumber[1] !== b.LegislationNumber[1]) {
        return a.LegislationNumber[1].localeCompare(b.LegislationNumber[1]);
    } else {
        const aLegislationKey = a.LegislationNumber.substr(2);
        const bLegislationKey = b.LegislationNumber.substr(2);
        return parseInt(aLegislationKey - bLegislationKey);
    }
}

export const LinkAsButton = (props) => {

    const self = useRef(null);

    const handleClick = (e) => {
        if (props.onClick) {
            e.preventDefault();
            e.stopPropagation();
            props.onClick();
            self.current?.blur();
        }
    };

    const handleKeyPress = (e) => {
        if (props.onClick && e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            e.stopPropagation();
            props.onClick();
            self.current?.blur();
        }
    }

    return <a ref={self} aria-label={props.ariaLabel ?? props.text} href={props.text} onClick={(e) => handleClick(e)}
        className={props.className ?? ''} style={props.style ?? {}} onKeyPress={(e) => handleKeyPress(e)} role="button" >{props.show ? props.text : ''}</a>
}

export const CustomOption = ({ children, ...props }) => {

    const [newWatchlist, setNewWatchlist] = useState("");

    const dupe = props.data.isNew && // Since we filter out the watchlists with this bill in bill details, we need to have some way to check for em.
        !!(props.options.slice(1).concat(props?.selectProps?.collectionsWithThisBill ?? [])).find(s => s.Name === newWatchlist);

    const selectOption = () => { };
    const stop = (e, focus) => {
        e.stopPropagation();
        focus && document.getElementById('add-new')?.focus();
        props.selectProps.toggleMenuIsOpen(true);
    }

    const newProps = props.data.isNew ?
        {
            ...props,
            selectOption,
            innerProps: {
                ...props.innerProps,
                onClick: (e) => stop(e)
            }
        } :
        props;

    const handleKeyPress = e => {
        e.stopPropagation();
        if (['Enter'].includes(e.key)) {
            e.preventDefault();
            addWatchlist();
        } else if (e.key === 'Tab') {
            if (e.shiftKey) {
                e.preventDefault();
                const clearAll = getClearAllIndicator(props.selectProps.id);
                if (clearAll && props.selectProps.value?.length > 0) {
                    clearAll.focus();
                } else {
                    e.stopPropagation();
                    const filterInput = getFilterInput(props.selectProps.id);
                    filterInput?.focus();
                }
            } else if (newWatchlist.length === 0 || dupe) {
            } else {
                e.preventDefault();
                e.stopPropagation();
                document.getElementById('add-new-button')?.focus();
            }
        } else if (e.key === 'ArrowDown') {
            e.preventDefault();
            props.selectProps.manuallyFocusTheNextOne('down');
        }
        else if (e.key === 'ArrowUp') {
            e.preventDefault();
            props.selectProps.manuallyFocusTheNextOne('up');
        }
    }

    const addWatchlist = (e) => {
        e?.preventDefault();
        if (newWatchlist.length === 0) return;
        props.selectProps.updateNew([...newProps.selectProps.value ?? [], { label: newWatchlist, value: newWatchlist, __isNew__: true }]);
        setNewWatchlist('');
        document.getElementById('add-watchlist-label')?.focus();
        setTimeout(() => props.selectProps.toggleMenuIsOpen(false));
    }

    const handleBlur = (e, acceptableId) => {
        if (![acceptableId, 'add-new-holder'].includes(e.relatedTarget?.id)) {
            props.selectProps.handleIsRelated(e, 'down');
        }
    }

    const handleButtonNavigation = e => {
        if (e.key === 'Tab') {
            if (e.shiftKey) {
                e.preventDefault();
                document.getElementById('add-new')?.focus();
            } else {
                e.preventDefault();
                props.selectProps.manuallyFocusTheNextOne('up', props.data);
            }
        } else if (e.key === 'ArrowDown') {
            e.preventDefault();
            props.selectProps.manuallyFocusTheNextOne('down');
        } else if (e.key === 'ArrowUp') {
            e.preventDefault();
            props.selectProps.manuallyFocusTheNextOne('up');
        }
    }

    return props.data.isNew ?
        <components.Option {...newProps}>
            <div id='add-new-holder' tabIndex={-1} style={{ display: 'grid', gridTemplateColumns: '1fr 25px', gap: '5px' }} >
                <input id='add-new' aria-label="New watchlist name" placeholder='Enter new watchlist name' value={newWatchlist} onChange={e => { e.preventDefault(); setNewWatchlist(e.target.value) }}
                    onMouseDown={e => stop(e)} onClick={(e => { stop(e, true) })} onKeyDown={handleKeyPress} onBlur={e => handleBlur(e, 'add-new-button')} />
                <div>
                    <button id='add-new-button' style={{ padding: '11px', marginTop: '2px', marginLeft: '5px', borderRadius: '10px', backgroundPosition: 'center', width: 'unset' }} disabled={newWatchlist.length === 0 || dupe} aria-label='enter new watchlist name' className='button add-wide' onClick={addWatchlist}
                        onKeyDown={e => { e.stopPropagation(); handleButtonNavigation(e) }} onKeyPress={e => { e.stopPropagation(); handleButtonNavigation(e) }} onKeyUp={e => e.stopPropagation()} onBlur={e => handleBlur(e, 'add-new')} />
                </div>
                {dupe && <DuplicateWatchlistWarning />}
            </div>
        </components.Option>
        :
        <components.Option {...props}>
            {children}
        </components.Option>
};

export const CustomClearIndicator = ({ children, ...props }) => {

    const newProps = {
        ...props,
        innerProps: {
            ...props.innerProps,
            'aria-hidden': false,
            tabIndex: 0,
            'aria-label': "clear current selections",
            onFocus: e => {
                e.preventDefault();
                e.stopPropagation();
                if (!props.selectProps.menuIsOpen) {
                    props.selectProps.toggleMenuIsOpen(true, { id: 'add-new' })
                }
            },
            onKeyDown: e => {
                if (e.key === 'Tab') {
                    e.preventDefault();
                    e.stopPropagation();
                    if (e.shiftKey) {
                        const filterInput = getFilterInput(props.selectProps.id);
                        filterInput?.focus();
                    } else {
                        const newInput = getNewInput(props.selectProps.id);
                        newInput?.focus();
                    }
                } else if (['Enter', ' '].includes(e.key)) {
                    e.preventDefault();
                    e.stopPropagation();
                    props.selectProps.onChange([], true);
                    const filterInput = getFilterInput(props.selectProps.id);
                    filterInput?.focus();
                }
            }
        },
    }


    return <components.ClearIndicator {...newProps}>
        {children}
    </components.ClearIndicator>
}

export const CustomMultiValueRemove = ({ children, ...props }) => {

    const newProps = {
        ...props,
        innerProps: {
            ...props.innerProps,
            tabIndex: 0,
            'aria-label': `Remove watchlist ${props.data.Name}`,
            onKeyDown: e => {
                if ([' ', 'Enter'].includes(e.key)) {
                    e.stopPropagation();
                    e.preventDefault();
                    const { value } = props.selectProps;
                    const selectedOptions = getSelectedOptions(props.selectProps.id);
                    const index = selectedOptions.findIndex(s => s === e.target)
                    props.selectProps.onChange(value.toSpliced(index, 1), true);
                    const filterInput = getFilterInput(props.selectProps.id);
                    filterInput?.focus();
                } else if (e.key === 'Tab') {
                    const selectedOptions = getSelectedOptions(props.selectProps.id);
                    const currentIndex = selectedOptions.findIndex(s => s === e.target);
                    if (e.shiftKey) {
                        if (currentIndex > 0) {
                            e.preventDefault();
                            e.stopPropagation();
                            selectedOptions[currentIndex - 1].focus();
                        }
                    } else {
                        e.preventDefault();
                        e.stopPropagation();
                        if (currentIndex === selectedOptions.length - 1) {
                            const filterInput = getFilterInput(props.selectProps.id);
                            filterInput?.focus();
                        } else {
                            selectedOptions[currentIndex + 1].focus();
                        }
                    }
                }
            },
            onFocus: e => {
                props.selectProps.toggleMenuIsOpen(true)
            }
        }
    }
    return <components.MultiValueRemove {...newProps}>
        {children}
    </components.MultiValueRemove>
}

export const CustomSelectContainer = ({ children, ...props }) => {

    const focusByMouse = useRef(false);

    const handlePointerDown = () => {
        focusByMouse.current = true;
    };

    const getFocusedMenuItemIndex = () => {
        const currentOption = props.selectProps.currentRef?.select?.state.focusedOption;
        const menuOptions = (props.selectProps.currentRef?.select?.state?.menuOptions?.focusable) ?? [];
        const jsonCurrentOption = JSON.stringify(currentOption ?? {});
        // PeRfOrMaNcE
        const currentIndex = menuOptions.findIndex(s => JSON.stringify(s) === jsonCurrentOption);
        return { currentIndex, menuOptionLength: menuOptions.length };
    }

    const newProps = {
        ...props,
        innerProps: {
            ...props.innerProps,
            onKeyDown: (e) => {
                if (e.target.tagName === 'INPUT') {
                    if (e.key === 'Tab') {
                        if (e.shiftKey) {
                            const selectedOptions = getSelectedOptions(props.selectProps.id);
                            if (selectedOptions.length > 0) {
                                e.preventDefault();
                                e.stopPropagation();
                                selectedOptions.at(-1).focus();
                            }
                        }
                        else {
                            e.preventDefault();
                            e.stopPropagation();
                            const clearAll = getClearAllIndicator(props.selectProps.id);
                            if (props.selectProps.value?.length > 0) {
                                clearAll?.focus();
                            } else {
                                const newInput = getNewInput(props.selectProps.id);
                                newInput?.focus();
                            }
                        }
                    } else if (e.key === 'ArrowDown') {
                        e.preventDefault();
                        const { currentIndex, menuOptionLength } = getFocusedMenuItemIndex();
                        props.selectProps.currentRef?.select?.focusOption('down');
                        if (currentIndex === menuOptionLength - 1) {
                            const newInput = getNewInput(props.selectProps.id);
                            setTimeout(() => newInput?.focus());
                        }
                    } else if (e.key === 'ArrowUp') {
                        e.preventDefault();
                        const { currentIndex } = getFocusedMenuItemIndex();
                        props.selectProps.currentRef?.select?.focusOption('up');
                        if (currentIndex === 1) {
                            const newInput = getNewInput(props.selectProps.id);
                            setTimeout(() => newInput?.focus());
                        }
                    } else if (e.key === 'Enter') {
                        const { currentIndex } = getFocusedMenuItemIndex();
                        if (currentIndex && currentIndex !== 0) {
                            const value = props.getValue() ?? [];
                            const menuOptions = (props.selectProps.currentRef?.select?.state?.menuOptions?.focusable) ?? [];
                            if (menuOptions.length > 0) {
                                props.selectProps.onChange(value.concat(menuOptions[currentIndex]), true);
                            }
                        }
                    }
                }
            },
            onPointerDown: handlePointerDown,
            onClick: e => {
            },
            onFocus: (e) => {
                e.preventDefault();
                e.stopPropagation();
                const relatedTarget = e.relatedTarget;
                const selectContainer = document.getElementById(props.selectProps.id);
                if (relatedTarget && selectContainer?.compareDocumentPosition(relatedTarget) === Node.DOCUMENT_POSITION_FOLLOWING && !props.selectProps.menuIsOpen) {
                    props.selectProps.toggleMenuIsOpen(true, { id: 'add-new' })
                } else if (!props.selectProps.menuIsOpen) {
                    props.selectProps.toggleMenuIsOpen(true);
                }
            },
            onPointerUp: e => {
                focusByMouse.current = false;
            }
        }
    }

    return <components.SelectContainer {...newProps} ariaLabel='hi'>
        {children}
    </components.SelectContainer>
}

export const CustomInput = ({ children, ...props }) => {
    return <components.Input {...props} aria-label='Filter watchlists. Arrow down to move to new watchlists. Tab to move to clear all watchlists. Shift tab to remove individual ones.'>
        {children}
    </components.Input>
}

const getFilterInput = selectId => {
    const container = document.getElementById(selectId);
    const input = Array.from(container?.getElementsByTagName('input') ?? []).at(0);
    return input;
}

const getSelectedOptions = selectId => {
    const container = document.getElementById(selectId);
    const selectedOptions = Array.from(container?.getElementsByClassName('no-width-dropdown-input__multi-value__remove') ?? []);
    return selectedOptions;
}

const getClearAllIndicator = selectId => {
    const container = document.getElementById(selectId);
    const indicator = Array.from(container?.getElementsByClassName('no-width-dropdown-input__indicator') ?? []).at(0);
    return indicator;
}

const getNewInput = selectId => {
    const container = document.getElementById(selectId);
    const tabInput = Array.from(container?.getElementsByTagName('input') ?? []).at(1);
    return tabInput;
}

export const DuplicateWatchlistWarning = (props) => <div className='dupe-warning-holder' style={{ ...props.styleAdjustments }}>
    <div className="dupe-warning-box">
        <p className='dupe-warning-message' aria-live='polite'>
            A watchlist with this name already exists.
        </p>
    </div>
</div>

export const printBillDetails = (printWindow, whichVersion, billData, collections, allPatrons, patronList, sessionData, summariesList) => {
    const printDiv = document.createElement('div');
    const billNumber = document.createElement('p');
    billNumber.textContent = `${sessionData.SessionYear} ${sessionData.DisplayName} | ${billData.LegislationNumber} | ${billData.LegislationStatus}`;
    printDiv.appendChild(billNumber);
    const billDescription = document.createElement('p');
    billDescription.textContent = billData.Description;
    printDiv.appendChild(billDescription);

    // Only something when its rendered. If so, include watchlists
    const watchlistTable = document.getElementsByClassName('watchlist-table');
    if (watchlistTable.length > 0) {
        const watchlists = collections.filter(c => c.WatchListLegislation.find(leg => leg.LegislationID === billData.LegislationID));
        if (watchlists.length > 0) {
            const watchlistDiv = document.createElement('div');
            watchlists.forEach(w => {
                const watchlistEl = document.createElement('div');
                watchlistEl.style.borderBottom = '1px solid lightgray';
                watchlistEl.style.marginBottom = '1px';
                const name = document.createElement('span');
                name.textContent = w.Name;
                const note = document.createElement('span');
                note.style.whiteSpace = 'pre-line';
                note.textContent = w.WatchListLegislation.find(c => c.LegislationID === billData.LegislationID)?.Note ?? '';
                if (note.textContent !== '') {
                    note.textContent = ' - ' + note.textContent;
                }
                watchlistEl.appendChild(name);
                watchlistEl.appendChild(note);
                watchlistDiv.appendChild(watchlistEl);
            });
            const watchlistsHeading = document.createElement('div');
            watchlistsHeading.textContent = `Watchlist${watchlists.length > 1 ? 's' : ''} with this bill`;
            watchlistsHeading.style.borderBottom = '1px solid lightgray';
            watchlistDiv.insertBefore(watchlistsHeading, watchlistDiv.childNodes[0]);
            watchlistDiv.style.paddingBottom = '15px';
            printDiv.appendChild(watchlistDiv);
        }
    }
    const createUl = () => {
        const ul = document.createElement('ul');
        ul.style.padding = 0;
        ul.style.margin = '1px 0 5px';
        ul.style.display = 'grid';
        ul.style.gridTemplateColumns = '1fr 1fr 1fr';
        ul.style.gridAutoFlow = 'column';
        return ul;
    }

    const applyRows = (chamberUl) => {
        const count = chamberUl.childNodes.length;
        const rows = Math.ceil(count / 3);
        let str = '';
        for (let i = 0; i < rows; i++) {
            str += '1fr ';
        }
        chamberUl.style.gridTemplateRows = str;
        return chamberUl;
    }
    const createLi = () => {
        const li = document.createElement('li');
        li.style.listStyle = 'none'
        li.style.padding = 0;
        li.style.margin = '1px 0';
        return li;
    }
    if (allPatrons) {
        const all = document.createElement('div');
        let house = createUl();
        let senate = createUl();
        const [chiefs, theRest] = patronList.reduce(([chiefs, theRest], p) => {
            if (p.PatronTypeID === 1) {
                chiefs.push(p);
            } else {
                theRest.push(p);
            }
            return [chiefs, theRest];
        }, [[], []]);
        const chiefsDiv = document.createElement('div');
        chiefsDiv.textContent = 'Introduced by: ' + chiefs.map(c => c.MemberDisplayName + c.DisplayName).join(', ');
        if (allPatrons) { // Add a label, it's probably not needed but it looked weird without
            const header = document.createElement('div');
            header.textContent = 'Patronage';
            chiefsDiv.insertBefore(header, chiefsDiv.childNodes[0]);
        }
        printDiv.appendChild(chiefsDiv);
        theRest.forEach(p => {
            if (p.PatronTypeID === 1) {
                return;
            }
            const li = createLi();
            li.textContent = p.MemberDisplayName + (p.DisplayName ?? '');
            if (p.ChamberCode === 'H') {
                house.appendChild(li);
            } else {
                senate.appendChild(li);
            }
        });
        const applyHouse = () => {
            if (house.children.length > 0) {
                const holder = document.createElement('div');
                const header = document.createElement('div');
                house = applyRows(house)
                header.textContent = 'House';
                holder.appendChild(header);
                header.appendChild(house);
                all.appendChild(holder);
            }
        }
        const applySenate = () => {
            if (senate.children.length > 0) {
                const holder = document.createElement('div');
                const header = document.createElement('div');
                senate = applyRows(senate)
                header.textContent = 'Senate';
                holder.appendChild(header);
                header.appendChild(senate);
                all.appendChild(holder);
            }
        }
        if (billData.LegislationNumber.includes('H')) {
            applyHouse();
            applySenate();
        } else {
            applySenate();
            applyHouse();
        }
        printDiv.appendChild(all);
    } else {
        const chiefs = patronList.filter(p => p.PatronTypeID === 1);
        const chiefsDiv = document.createElement('div');
        chiefsDiv.textContent = 'Introduced by: ' + chiefs.map(c => c.MemberDisplayName + c.DisplayName).join(', ');
        printDiv.appendChild(chiefsDiv);
    }
    const summaries = document.createElement('div');
    summariesList.forEach(s => {
        const summaryTitle = document.createElement('p');
        summaryTitle.style.margin = '15px 0 0';
        summaryTitle.textContent = s.SummaryVersion;
        const summary = document.createElement('div');
        summary.innerHTML = s.Summary;
        Array.from(summary.children).forEach(p => {
            if (p.nodeName === 'P') { // only p tags? can there be a table
                p.style.margin = '5px 0 5px';
            }
        })
        summaries.appendChild(summaryTitle);
        summaries.appendChild(summary)
    });
    printDiv.appendChild(summaries);

    const createRowDiv = () => {
        const div = document.createElement('div');
        div.style.display = 'grid';
        div.style.gridTemplateColumns = '100px 100px 1fr';
        div.style.borderBottom = '1px solid';
        return div;
    }
    if (whichVersion === 'new') {
        const eventRows = document.getElementsByClassName('history-event-row');
        Array.from(eventRows).forEach(r => {
            const rowDiv = createRowDiv();
            const spans = r.getElementsByTagName('span');
            Array.from(spans).forEach(s => {
                if (s.parentElement?.nodeName !== 'SPAN') {
                    const sp = document.createElement('span');
                    sp.textContent = s.textContent;
                    rowDiv.appendChild(sp);
                }
            })
            printDiv.appendChild(rowDiv);
        });
    } else {
        const eventRows = document.getElementsByClassName('bill-details-table-row');
        Array.from(eventRows).forEach(r => {
            const rowDiv = createRowDiv();
            Array.from(r.children).forEach(c => {
                if (!c.classList.contains('button-container')) {
                    const sp = document.createElement('span');
                    sp.textContent = c.textContent;
                    rowDiv.appendChild(sp);
                }
            });
            printDiv.appendChild(rowDiv);
        })
    }
    printWindow.contentDocument.body.innerHTML = printDiv.outerHTML;
    printWindow.focus();
    setTimeout(() => printWindow.contentWindow.print(), 10);
}
